import { render, staticRenderFns } from "./UILoader.vue?vue&type=template&id=7fd8f441"
import script from "./UILoader.vue?vue&type=script&lang=js"
export * from "./UILoader.vue?vue&type=script&lang=js"
import style0 from "./UILoader.vue?vue&type=style&index=0&id=7fd8f441&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports